import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const userProfileSlice = createSlice({
	name: 'userProfile',
	initialState,
	reducers: {
		setUserProfile(state, action) {
			return action.payload;
		}
	}
});

export const { setUserProfile } = userProfileSlice.actions;

export default userProfileSlice.reducer;
